import { ArrowUpRight, Landmark, ShoppingCart, Warehouse } from 'lucide-react';
import { permissionForPath } from '@klothiq/domain';
import Link from '@/components/common/AccessLink';
import { useAuth } from '@/contexts/AuthContext';

const shortcuts = [
  { label: 'Sales', to: '/sales', icon: ShoppingCart },
  { label: 'Accounts', to: '/accounts', icon: Landmark },
  { label: 'Inventory', to: '/inventory', icon: Warehouse },
] as const;

export default function DashboardQuickMenu() {
  const { can } = useAuth();
  const available = shortcuts.filter(({ to }) => {
    const permission = permissionForPath(to);
    return !permission || can(permission);
  });
  if (!available.length) return null;

  return (
    <nav aria-label="Dashboard quick menu" className="space-y-2">
      <h2 className="text-sm font-semibold">Quick menu</h2>
      <div
        className={`grid gap-2 sm:gap-3 ${available.length === 1 ? 'grid-cols-1' : available.length === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}
      >
        {available.map(({ label, to, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="dashboard-card dashboard-link flex min-h-11 min-w-0 flex-col items-center gap-2 rounded-2xl border border-border bg-card p-3 text-center text-xs font-semibold transition-colors hover:border-primary/40 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:flex-row sm:gap-3 sm:p-4 sm:text-left sm:text-sm"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-cyan-700 dark:text-primary">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <span>{label}</span>
            <ArrowUpRight
              className="ml-auto hidden h-4 w-4 shrink-0 text-muted-foreground sm:block"
              aria-hidden="true"
            />
          </Link>
        ))}
      </div>
    </nav>
  );
}
